import React, { Component } from "react";

import { Row, Col, Button, Typography, Modal, message, Card, Tabs, TreeSelect, Icon } from "antd";
import "./dealshubadmin.scss";
import Loader from "../../components/Loader/Loader";

import { connect } from "react-redux";

import {
    addcategory,
    addBanner,
    fetchDealsHubCategoryData,
    handleUpdate,
    orderList,
    handleDelete,
} from "../../actions/dealsHubAdmin";

import { SortableContainer, SortableElement } from "react-sortable-hoc";
import GenericBanner from "./generic-banner/GenericBanner";
import banner from "./../../media/banner.png";
import grid from "./../../media/grid.png";
import axios from "axios";
import isDev from "../../server";

const serverUrl = isDev();

const { Text } = Typography;
const { TabPane } = Tabs;

const SortableItem = SortableElement((props) => {
    return (
        <Row
            className='categoriescontainer'
            style={{ backgroundColor: props.bgColor ? "#EAF4EC" : "#fff" }}
            key={props.sectionData.uuid}>
            <Col xs={24}>
                <div className='collapse-div'>
                    <GenericBanner
                        // activeIndex={props.activeIndex}
                        bgColor={props.bgColor}
                        id={props.index}
                        grid={grid}
                        banner={banner}
						fetchSortedSection = {props.fetchSortedSection}
                        fetchInitialData={props.fetchInitialData}
                        spinnerOn={props.spinnerOn}
                        bannerData={props.sectionData}
                        bannerIndex={props.sectionIndex}
                        locationUuid={props.locationUuid}
                    />
                </div>
            </Col>
        </Row>
    );
});

const ListHeader = () => {
    return (
        <Row
            style={{
                marginBottom: "4px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #F2F2F2",
                backgroundColor: "#F2F2F2",
            }}>
            <Col span={7}>
                <Text className='header-text' style={{ marginLeft: "52px" }}>
                    Promotion Name
                </Text>
            </Col>
            <Col span={5}>
                <Text className='header-text' style={{ marginLeft: "18px" }}>
                    Created on
                </Text>
            </Col>
            <Col span={5}>
                <Text
                    className='header-text'
                    // style={{marginLeft: '20px'}}
                >
                    Promotion Type
                </Text>
            </Col>
            <Col span={7} style={{ marginLeft: "-6px" }}>
                <Text className='header-text'>Status</Text>
            </Col>
        </Row>
    );
};

const SortableList = SortableContainer((props) => {
    // const [activeIndex, setActiveIndex] = useState(null)
    return (
        <ul className='row wrapper-ul-row'>
            {" "}
            {props.items.map((section, index) => (
                <Row
                    key={index}
                    onClick={() => {
                        props.setActiveIndex(index);
                    }}>
                    <SortableItem
                        // activeIndex={props.activeIndex+1}
                        bgColor={props.activeIndex === index ? true : false}
                        key={`item-${section.uuid}`}
                        index={index}
                        // sectionIndex={index+1}
                        sectionIndex={index}
						fetchSortedSection = {props.fetchSortedSection}
                        fetchInitialData={props.fetchInitialData}
                        sectionData={section}
                        deleteCategory={props.deleteCategory}
                        spinnerOn={props.spinnerOn}
                        locationUuid={props.locationUuid}
                    />
                </Row>
            ))}
        </ul>
    );
});

class DealsHubAdmin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchingAdminSections: true,
            fetchingAdminSectionTypes: true,
            adminSectionTypeChangedValue: "",
            adminSectionTypeChangedLimit: 0,
            serverUrl: serverUrl,
            spinnerLoading: false,
            bannerTypes: null,
            displayBannerModal: false,
            bannerRadioValue: null,
            ItemLength: 1,
            searchListing: [],
            addCategoryInProgress: false,
            saveOrderInProgress: false,
            addBannerInProgress: false,
            isSelectSectionModalTypeVisible: false,
            adminSectionTypes: null,
            activeIndex: null,
            treeData: null,

            selectedTreeNode: null,
            // selectedTab: null,
        };
    }

    spinnerOn = (status) => {
        this.setState({ spinnerLoading: status });
    };

	fetchSortedSection = ({promotion_list2,index})=>{
		let newBannerlist = this.props.dealsHubAdmin;
		newBannerlist[index]= {...newBannerlist[index], promo_list:promotion_list2};
		this.props.fetchDealsHubCategoryData(newBannerlist);
        this.setState({
            treeData: newBannerlist.map((section) => ({
                title: section.name,
                value: section.uuid,
                key: section.uuid,
                children: section.promo_list.length
                    ? section.promo_list.map((promoObj) => ({
                          title: promoObj.title,
                          value: `${section.uuid}&${promoObj.uuid}`,
                          key: promoObj.uuid,
                      }))
                    : null,
            })),
        });

	}

    changeSectionStatus = (index,sectiondata)=>{
        let sectionlist = this.props.dealsHubAdmin;
        sectionlist[index] = sectiondata;
        this.props.fetchDealsHubCategoryData(sectionlist);
    }

    sortsectionlist = (sectionlist)=>{
        let sectionlist1 = sectionlist;
        sectionlist1.sort((a,b)=>{
            if (a["order_index"] > b["order_index"]) {    
                return 1;    
            } else if (a["order_index"] < b["order_index"]) {    
                return -1;    
            }    
            return 0;
        })
        for (let sectionindex in sectionlist1){
            sectionlist1[sectionindex].promo_list.sort((a,b)=>{
                if (a["order_index"] > b["order_index"]) {    
                    return 1;    
                } else if (a["order_index"] < b["order_index"]) {    
                    return -1;    
                }    
                return 0;
            })

        }

        return sectionlist1;
    }

    fetchInitialData = () => {
        this.setState(
            {
                fetchingAdminSections: true,
            },
            () => {
                axios
                    .post(
                        `${serverUrl}/${
                            JSON.parse(localStorage.getItem("countryData")).database_identifier
                        }/section/fetch-section-list-admin/`,
                        {
                            permission_category:["STORE_CONTROL_CENTER"]
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `JWT ${localStorage.getItem("token")}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            let finalSectionObj = response.data.section_list;
                            
                            for (let sectionObjIndex in response.data.section_list) {
                                let sectionObj = finalSectionObj[sectionObjIndex];
                                
                                for (let promoObjIndex in sectionObj.promo_list) {
                                    let promoObj = sectionObj.promo_list[promoObjIndex];

                                    let tempInnerImage = [];
                                    let tempOuterImage = [];

                                    if (promoObj.inner_images && promoObj.type === 'flyer') {
                                        promoObj.inner_images.map((imageObject, index) =>
                                            tempInnerImage.push({
                                                uid: imageObject.uuid,
                                                name: `${promoObj.title}'s image number ${index}`,
                                                status: "done",
                                                url: imageObject.url,
                                            })
                                        );
                                    }

                                    if (promoObj.inner_image && promoObj.type !== 'flyer') {
                                            tempInnerImage.push({
                                                uid: promoObj.inner_image.uuid,
                                                name: `${promoObj.title}'s image number`,
                                                status: "done",
                                                url: promoObj.inner_image.url,
                                            })
                                        }

                                    if (promoObj.outer_image ) {
                                        tempOuterImage.push({
                                            uid: promoObj.outer_image.uuid,
                                            name: `${promoObj.title}'s outer image`,
                                            status: "done",
                                            url: promoObj.outer_image.url,
                                        });
                                    }

                                    finalSectionObj[sectionObjIndex].promo_list[promoObjIndex].inner_image =
                                    tempInnerImage;
                                    finalSectionObj[sectionObjIndex].promo_list[promoObjIndex].outer_image =
                                    tempOuterImage;
                                }
                            }
                            finalSectionObj = this.sortsectionlist(finalSectionObj);
                            this.props.fetchDealsHubCategoryData(finalSectionObj);
                            

                            this.setState({
                                treeData: response.data.section_list.map((section) => ({
                                    title: section.name,
                                    value: section.uuid,
                                    key: section.uuid,
                                    children: section.promo_list?.length
                                        ? section.promo_list.map((promoObj) => ({
                                              title: promoObj.title,
                                              value: `${section.uuid}&${promoObj.uuid}`,
                                              key: promoObj.uuid,
                                          }))
                                        : null,
                                })),
                                fetchingAdminSections: false,
                            });
                        } else if (response.data.status === 405) {
                            message.info("You are not authorised!");
                        } else {
                            message.error("Something went wrong!");
                        }
                    });
            }
        );
    };

    fetchSectionTypes = () => {
        axios
            .post(
                `${serverUrl}/${
                    JSON.parse(localStorage.getItem("countryData")).database_identifier
                }/section/fetch-section-types/`,
                {
                    permission_category:["STORE_CONTROL_CENTER"]
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `JWT ${localStorage.getItem("token")}`,
                    },
                }
            )
            .then((response) => {
                if (response.data.status === 200) {
                    this.setState(
                        {
                            fetchingAdminSectionTypes: true,
                            adminSectionTypes: response.data.section_type_list,
                            // adminSectionTypeChangedValue: response.data.section_type_list[0].name,
                            // adminSectionTypeChangedLimit: response.data.section_type_list[0].limit
                        },
                        () => {
                            this.setState({
                                fetchingAdminSectionTypes: false,
                            });
                        }
                    );
                } else if (response.data.status === 405) {
                    message.info("You are not authorised!");
                } else {
                    message.error("Something went wrong!");
                }
            });
    };

    componentDidMount = () => {
        this.fetchInitialData();
        this.fetchSectionTypes();
        this.setState({ locationUuid: this.props.locationUuid });
    };

    componentDidUpdate = (prevState, prevProps) => {
        if (prevState.locationUuid !== this.state.locationUuid) this.fetchInitialData();
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locationUuid !== prevState.locationUuid) {
            return {
                locationUuid: nextProps.locationUuid,
            };
        }

        return null;
    }

    adminSectionTypeChanged = (value) => {
        // console.log(value);
        // adminSectionTypeChangedValue: response.data.section_type_list[0].substr(0, response.data.section_type_list.indexOf("$")),
        //         adminSectionTypeChangedLimit: response.data.section_type_list[0].substr(response.data.section_type_list.indexOf("$"), -1)
        this.setState({
            adminSectionTypeChangedValue: value.substr(0, value.indexOf("$")),
            adminSectionTypeChangedLimit: value.substr(value.indexOf("$") + 1),
        });
    };

    saveOrdering = () => {
        this.setState(
            {
                saveOrderInProgress: true,
            },
            () => {
                let tempSectionsList = [];
                this.props.dealsHubAdmin.map((kvp) => tempSectionsList.push(kvp.uuid));
                axios
                    .post(
                        `${this.state.serverUrl}/${
                            JSON.parse(localStorage.getItem("countryData")).database_identifier
                        }/section/reorder-section-list/`,
                        {
                            section_list: tempSectionsList,
                            permission_category:["STORE_CONTROL_CENTER"]
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `JWT ${localStorage.getItem("token")}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            message.success("Orders applied Successfully!");
                            this.setState({ saveOrderInProgress: false });
                        } else if (response.data.status === 405) {
                            message.info("You are not authorised!");
                        } else {
                            message.error("Something went wrong!");
                        }
                    });
            }
        );
    };

    changeBannerRadioValue = (event) => {
        this.setState({
            bannerRadioValue: event.target.value,
        });
    };

    toggleOpenAddSectionModal = () => {
        this.setState({
            isSelectSectionModalTypeVisible: !this.state.isSelectSectionModalTypeVisible,
        });
    };

    addCategory = (param) => {
        this.setState(
            {
                addCategoryInProgress: true,
            },
            () => {
                
                axios
                    .post(
                        `${serverUrl}/${
                            JSON.parse(localStorage.getItem("countryData")).database_identifier
                        }/section/create-section/`,
                        {
                            name: `Section ${this.props.dealsHubAdmin.length + 1}`,
                            section_type: this.state.adminSectionTypeChangedValue,
                            permission_category:["STORE_CONTROL_CENTER"]
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `JWT ${localStorage.getItem("token")}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            this.fetchInitialData();
                            message.success("Section created Successfully!");
                            this.setState({
                                addCategoryInProgress: false,
                                isSelectSectionModalTypeVisible: false,
                                adminSectionTypeChangedValue: this.state.adminSectionTypes[0].name,
                                adminSectionTypeChangedLimit: this.state.adminSectionTypes[0].limit,
                            });
                        } else if (response.data.status === 405) {
                            message.info("You are not authorised!");
                        } else {
                            message.error("Something went wrong!");
                        }
                    });
            }
        );
    };

    deleteCategory = (requiredIndex) => {
        this.setState(
            {
                spinnerLoading: true,
            },
            () => {
                // var tempState = this.props.dealsHubAdmin.splice(requiredIndex, 1);
                this.props.handleDelete(this.props.dealsHubAdmin);
                this.setState({ spinnerLoading: false });
            }
        );
    };

    setActiveIndex = (newIndex) => {
        this.setState({
            activeIndex: newIndex,
        });
    };

    willReceiveProps = () => {
        this.setState({
            ItemLength: this.props.dealsHubAdmin.length,
            spinnerLoading: false,
        });
    };

    render() {
        if (this.state.ItemLength !== this.props.dealsHubAdmin.length) {
            this.willReceiveProps();
        }

        if (this.state.fetchingAdminSections && this.state.fetchingAdminSectionTypes) {
            return (
                <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#FAFAFA",
                    }}>
                    <Loader />
                </div>
            );
        } else {
            return (
                <React.Fragment>
                    <Row className='dealshubadmincontainer'>
                        <Row className='buttons' type='flex' justify='space-between' align='middle'>
                            {/* <Col span={12}> */}
                            <Text style={{ color: "#181818", fontWeight: "bold", fontSize: "24px", cursor: "default" }}>
                                Promotions
                            </Text>
                            {/* </Col> */}
                            {/* <Col span={12} align="end"> */}
                            {/*<Button type="primary"*/}
                            {/*        onClick={this.saveOrdering}*/}
                            {/*        loading={this.state.saveOrderInProgress}*/}
                            {/*        disabled={this.state.addCategoryInProgress || this.state.addBannerInProgress}*/}
                            {/*>Save Order</Button>*/}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}>
                                <TreeSelect
                                    treeData={this.state.treeData}
                                    showSearch
                                    allowClear
                                    treeNodeFilterProp='title'
                                    dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                                    onChange={(value) => {
                                        this.setState({ selectedTreeNode: value?.split("&")[0] });
                                    }}
                                    treeDefaultExpandAll
                                    placeholder={
                                        <>
                                            <Icon type='search' />{" "}
                                            <Text style={{ paddingLeft: 10 }}>Search Promotions</Text>
                                        </>
                                    }
                                    style={{
                                        width: "280px",
                                        border: "1px solid #D9D9D9",
                                        borderRadius: 5,
                                        marginRight: 15,
                                        height: 40,
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                />
                                <Button
                                    style={{
                                        background: "#fec708",
                                        color: "#fff",
                                        border: "none",
                                        height: "40px",
                                        padding: "8px 16px",
                                        borderRadius: "5px",
                                        fontSize: 16,
                                    }}
                                    // onClick={this.addCategory}
                                    onClick={this.toggleOpenAddSectionModal}
                                    loading={this.state.addCategoryInProgress}
                                    disabled={this.state.addBannerInProgress || this.state.saveOrderInProgress}>
                                    <Icon type='plus' />
                                    Create Promotion
                                </Button>
                            </div>
                            {/* </Col> */}
                        </Row>
                        <Tabs defaultActiveKey='1'>
                            <TabPane
                                tab={`All (${
                                    this.props.dealsHubAdmin.filter(
                                        (section) =>
                                            !this.state.selectedTreeNode || section.uuid === this.state.selectedTreeNode
                                    ).length
                                })`}
                                key='1'>
                                <ListHeader />
                                <SortableList
                                    items={this.props.dealsHubAdmin.filter(
                                        (section) =>
                                            !this.state.selectedTreeNode || section.uuid === this.state.selectedTreeNode
                                    )}
                                    activeIndex={this.state.activeIndex}
                                    setActiveIndex={this.setActiveIndex}
                                    deleteCategory={this.deleteCategory}
                                    spinnerOn={this.spinnerOn}
									fetchSortedSection =
                                     {this.fetchSortedSection}
                                    fetchInitialData={this.fetchInitialData}
                                    onSortEnd={(item) => {
                                        this.props.orderList(item);
                                        setTimeout(this.saveOrdering, 100);
                                        this.setState({
                                            activeIndex: item.newIndex,
                                        });
                                    }}
                                    //  onSortEnd={this.props.orderList}
                                    axis='xy'
                                    distance={2}
                                    locationUuid={this.props.locationUuid}
                                />
                            </TabPane>
                            <TabPane
                                tab={`Grid (${
                                    this.props.dealsHubAdmin.filter(
                                        (section) =>
                                            section.type.name === "Grid" &&
                                            (!this.state.selectedTreeNode ||
                                                section.uuid === this.state.selectedTreeNode)
                                    ).length
                                })`}
                                key='2'>
                                <ListHeader />
                                <SortableList
                                    items={this.props.dealsHubAdmin.filter(
                                        (section) =>
                                            section.type.name === "Grid" &&
                                            (!this.state.selectedTreeNode ||
                                                section.uuid === this.state.selectedTreeNode)
                                    )}
                                    activeIndex={this.state.activeIndex}
                                    setActiveIndex={this.setActiveIndex}
                                    fetchSortedSection = {this.fetchSortedSection}
                                    fetchInitialData={this.fetchInitialData}
                                    deleteCategory={this.deleteCategory}
                                    spinnerOn={this.spinnerOn}
                                    onSortEnd={(item) => {
                                        // console.log(item)
                                        this.props.orderList(item);
                                        setTimeout(this.saveOrdering, 100);
                                        this.setState({
                                            activeIndex: item.newIndex,
                                        });
                                    }}
                                    axis='xy'
                                    distance={2}
                                    locationUuid={this.props.locationUuid}
                                />
                            </TabPane>
                            <TabPane
                                tab={`Banner Ad (${
                                    this.props.dealsHubAdmin.filter(
                                        (section) =>
                                            section.type.name === "BannerAd" &&
                                            (!this.state.selectedTreeNode ||
                                                section.uuid === this.state.selectedTreeNode)
                                    ).length
                                })`}
                                key='3'>
                                <ListHeader />
                                <SortableList
                                    items={this.props.dealsHubAdmin.filter(
                                        (section) =>
                                            section.type.name === "BannerAd" &&
                                            (!this.state.selectedTreeNode ||
                                                section.uuid === this.state.selectedTreeNode)
                                    )}
                                    activeIndex={this.state.activeIndex}
                                    setActiveIndex={this.setActiveIndex}
                                    fetchSortedSection = {this.fetchSortedSection}
                                    fetchInitialData={this.fetchInitialData}
                                    deleteCategory={this.deleteCategory}
                                    spinnerOn={this.spinnerOn}
                                    onSortEnd={(item) => {
                                        // console.log(item)
                                        this.props.orderList(item);
                                        setTimeout(this.saveOrdering, 100);
                                        this.setState({
                                            activeIndex: item.newIndex,
                                        });
                                    }}
                                    axis='xy'
                                    distance={2}
                                    locationUuid={this.props.locationUuid}
                                />
                            </TabPane>
                        </Tabs>

                        {!this.state.fetchingAdminSections && this.props.dealsHubAdmin.length === 0 ? (
                            <Row
                                type='flex'
                                justify='center'
                                align='middle'
                                style={{
                                    marginTop: "100px",
                                }}>
                                <h5
                                    style={{
                                        color: "#fff",
                                    }}>
                                    No Sections Added
                                </h5>
                            </Row>
                        ) : (
                            <Row
                                type='flex'
                                justify='center'
                                align='middle'
                                style={{
                                    marginTop: "100px",
                                }}
                            />
                        )}
                    </Row>
                    <Modal
                        visible={this.state.isSelectSectionModalTypeVisible}
                        footer={null}
                        onCancel={() => {
                            this.setState(
                                {
                                    adminSectionTypeChangedValue: this.state.adminSectionTypes[0].name,
                                    adminSectionTypeChangedLimit: this.state.adminSectionTypes[0].limit,
                                },
                                () => {
                                    this.toggleOpenAddSectionModal();
                                }
                            );
                        }}
                        // width={"70vw"}
                        destroyOnClose={true}
                        style={{
                            minWidth: "536px",
                            backgroundColor: "#fff",
                        }}
                        bodyStyle={{
                            background: "#fff",
                        }}>
                        {this.state.adminSectionTypes && this.state.adminSectionTypes.length > 0 ? (
                            <Row>
                                <Row className={"modal-row"}>
                                    <Text
                                        style={{
                                            fontWeight: "bold",
                                            color: "#181818",
                                            fontSize: "24px",
                                            // fontFamily: 'Gotham'
                                        }}>
                                        Select Type of Promotion
                                    </Text>
                                </Row>
                                <Row
                                    style={{
                                        margin: "24px 0px 0px",
                                    }}
                                    gutter={[24, 24]}
                                    type={"flex"}
                                    justify={"space-between"}
                                    align={"middle"}>
                                    <Col span={24} style={{ padding: "0px" }}>
                                        <Col
                                            xs={24}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            style={{ padding: "0px 24px 0px 0px" }}>
                                            <div
                                                onClick={() => {
                                                    this.setState({
                                                        adminSectionTypeChangedValue:
                                                            this.state.adminSectionTypes[0].name,
                                                        adminSectionTypeChangedLimit:
                                                            this.state.adminSectionTypes[0].limit,
                                                    });
                                                }}>
                                                <Card
                                                    style={{
                                                        minWidth: "232px",
                                                        cursor: "pointer",
                                                        textAlign: "center",
                                                        borderRadius: "10px",
                                                        boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
                                                        border:
                                                            this.state.adminSectionTypeChangedValue ===
                                                            this.state.adminSectionTypes[0].name
                                                                ? "1px solid #fec708"
                                                                : "1px solid #F2F2F2",
                                                    }}>
                                                    <img
                                                        src={grid}
                                                        style={{ marginBottom: "16px" }}
                                                        alt='Illustration for grid promo'
                                                    />
                                                    <Text
                                                        style={{
                                                            fontSize: "16px",
                                                            color: "#181818",
                                                        }}>
                                                        Grid
                                                    </Text>
                                                </Card>
                                            </div>
                                        </Col>
                                        <Col
                                            xs={24}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            style={{ padding: "0px 24px 0px 0px" }}>
                                            <div
                                                onClick={() => {
                                                    this.setState({
                                                        adminSectionTypeChangedValue:
                                                            this.state.adminSectionTypes[1].name,
                                                        adminSectionTypeChangedLimit:
                                                            this.state.adminSectionTypes[1].limit,
                                                    });
                                                }}>
                                                <Card
                                                    style={{
                                                        minWidth: "232px",
                                                        cursor: "pointer",
                                                        textAlign: "center",
                                                        borderRadius: "10px",
                                                        boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
                                                        border:
                                                            this.state.adminSectionTypeChangedValue ===
                                                            this.state.adminSectionTypes[1].name
                                                                ? "1px solid #fec708"
                                                                : "1px solid #F2F2F2",
                                                    }}>
                                                    <img
                                                        src={banner}
                                                        style={{ marginBottom: "16px", marginRight: "14px" }}
                                                        alt='Illustration for banner promo'
                                                    />
                                                    <Text
                                                        style={{
                                                            fontSize: "16px",
                                                            color: "#181818",
                                                        }}>
                                                        Banner
                                                    </Text>
                                                </Card>
                                            </div>
                                        </Col>
                                    </Col>
                                    <Col span={24} style={{ textAlign: "right", marginTop: "40px" }}>
                                        <Button
                                            onClick={this.addCategory}
                                            size='large'
                                            disabled={this.state.addCategoryInProgress}
                                            style={{
                                                width: "200px",
                                                height: "40px",
                                                borderRadius: "5px",
                                                border: "none",
                                                backgroundColor:
                                                    this.state.adminSectionTypeChangedValue === ""
                                                        ? "#E8E8E8"
                                                        : "#fec708",
                                                color:
                                                    this.state.adminSectionTypeChangedValue === ""
                                                        ? "#747474"
                                                        : "#FFFFFF",
                                            }}>
                                            Continue
                                        </Button>
                                    </Col>
                                </Row>
                            </Row>
                        ) : (
                            ""
                        )}
                    </Modal>
                </React.Fragment>
            );
        }
    }
}

const mapStateToProps = ({ dealsHubAdmin }) => {
    return {
        dealsHubAdmin,
    };
};

export default connect(mapStateToProps, {
    addcategory,
    addBanner,
    fetchDealsHubCategoryData,
    handleUpdate,
    orderList,
    handleDelete,
})(DealsHubAdmin);
